import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ContextMenuService } from 'app/core/services/context-menu/context-menu.service';
import { ContextMenuLineModel } from 'app/core/services/context-menu/models/context-menu-line-model';
import { MatIconButton } from '@angular/material/button';
import { ContextMenuDirective } from '../../../../core/services/context-menu/context-menu.directive';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-print-action-buttons',
  styleUrls: ['./print-action-buttons.component.scss'],
  templateUrl: './print-action-buttons.component.html',
  imports: [MatIconButton, ContextMenuDirective, MatTooltip, MatIcon],
})
export class PrintActionButtonsComponent {
  @Output() public downloadFecButtonClickedEvent = new EventEmitter<void>();
  @Input() public downloadFecFlag = false;
  @Input() public downloadFecLabel = 'Télécharger le fichier FEC';

  @Output() public downloadPdfButtonClickedEvent = new EventEmitter<void>();
  @Input() public downloadPdfDisabledFlag = false;
  @Input() public downloadPdfFlag = false;
  @Input() public downloadPdfLabel = 'Télécharger le PDF';
  @Input() public downloadPdfMenuContextLines: ContextMenuLineModel[] | undefined;

  @Output() public downloadSpreadsheetButtonClickedEvent = new EventEmitter<void>();
  @Input() public downloadSpreadsheetFlag = false;
  @Input() public downloadSpreadsheetLabel = 'Télécharger le fichier Excel';

  @Output() public downloadUblButtonClickedEvent = new EventEmitter<void>();
  @Input() public downloadUblDisabledFlag = false;
  @Input() public downloadUblFlag = false;
  @Input() public downloadUblLabel = 'Télécharger le fichier UBL';

  @Output() public downloadZipButtonClickedEvent = new EventEmitter<void>();
  @Input() public downloadZipDisabledFlag = false;
  @Input() public downloadZipFacturXBadgeFlag = false;
  @Input() public downloadZipFlag = false;
  @Input() public downloadZipLabel = 'Télécharger le fichier Zip';
  @Input() public downloadZipUblBadgeFlag = false;

  @Input() public facturXFlag: boolean | undefined = false;

  @Output() public generateMultiplePdfButtonClickedEvent = new EventEmitter<void>();
  @Input() public generateMultiplePdfFlag: boolean | undefined = false;
  @Input() public generateMultiplePdfLabel = 'Obtenir les PDF multiples';
  @Input() public generateMultiplePdfMenuContextLines: ContextMenuLineModel[];

  // Determines if there is selected elements to apply the buttons.
  @Input() public hasSelectedElementFlag = true;

  @Input() public multipleActionFlag = false;

  @Output() public multiplePreviewButtonClickedEvent = new EventEmitter<void>();
  @Input() public multiplePreviewFlag = false;
  @Input() public multiplePreviewLabel = 'Aperçu des documents';

  @Output() public openPdfButtonClickedEvent = new EventEmitter<void>();
  @Input() public openPdfDisabledFlag = false;
  @Input() public openPdfFlag = false;
  @Input() public openPdfLabel = 'Ouvrir le PDF';
  @Input() public openPdfMenuContextLines: ContextMenuLineModel[] | undefined;

  @Output() public toggleSelectionFlag = new EventEmitter<void>();

  private _contextMenuService = inject(ContextMenuService);

  public closeMenuContextHandler($event: MouseEvent): void {
    this._contextMenuService.hideContextMenuEvent.next($event);
  }

  public downloadFecLabelButtonClickedHandler(event: Event): void {
    event.stopPropagation();
    this.downloadFecButtonClickedEvent.emit();
  }

  public downloadPdfLabelButtonClickedHandler(event: Event): void {
    event.stopPropagation();
    this.downloadPdfButtonClickedEvent.emit();
  }

  public downloadSpreadsheetLabelButtonClickedHandler(event: Event): void {
    event.stopPropagation();
    this.downloadSpreadsheetButtonClickedEvent.emit();
  }

  public downloadUblButtonClickedHandler(event: Event): void {
    event.stopPropagation();
    this.downloadUblButtonClickedEvent.emit();
  }

  public downloadZipLabelButtonClickedHandler(event: Event): void {
    event.stopPropagation();
    this.downloadZipButtonClickedEvent.emit();
  }

  public generateMultiplePdfButtonClickedHandler(event: Event): void {
    event.stopPropagation();
    this.toggleSelectionFlag.emit();
    this.generateMultiplePdfButtonClickedEvent.emit();
  }

  public multiplePreviewButtonClickedHandler(event: Event): void {
    event.stopPropagation();
    this.toggleSelectionFlag.emit();
    this.multiplePreviewButtonClickedEvent.emit();
  }

  public openPdfButtonClickedHandler(event: Event): void {
    event.stopPropagation();
    this.openPdfButtonClickedEvent.emit();
  }
}
